export default __webpack_public_path__ + "static/activities_image_four_mobile-80c972f3aca75b792ed8425189ec4b5f.jpg";